import React from "react";
import PolicyLayout from "./PolicyLayout";

const sections = [
  <>Thank you for shopping at <b>Alpaago</b>. If you are not entirely satisfied with your purchase, we’re here to help.</>,
  <>Refunds are applicable only for items purchased directly through our website. Requests must be made within <b>7 business days</b> of delivery.</>,
  <>Approved refunds will be credited to your original payment method within <b>5–7 business days</b>.</>,
  <>For refund requests, please email us at <b>contact@alpaago.com</b> or call <b>+91 73974 60454</b>.</>,
];

export default function RefundPolicy() {
  return <PolicyLayout title="Refund Policy" sections={sections} />;
}
